import { FC } from "react";

import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";

import { IImageProps } from "../../base/Image/Image";
import TextBody from "../../base/Text/TextBody/TextBody";
import TextSubtitle from "../../base/Text/TextSubtitle/TextSubtitle";

import FrameImage from "./FrameImage";

export interface IQuoteBanner {
  quote: string;
  author: string;
  image: IImageProps;
  styleOptions: {
    bannerFillColour?: Theme;
    frameFillColour?: Theme;
  }
}

const QuoteBanner: FC<IQuoteBanner> = ({ quote, author, image, styleOptions }) => (
  <div data-component={QuoteBanner.name} className={`w-full rounded p-3 md:p-4 ${themeRootClassMap[styleOptions.bannerFillColour ?? "light-blue"]}`}>
    <div className="flex gap-x-2">
      <FrameImage image={image} author={author} frameFillColour={styleOptions.frameFillColour ?? "green"} />

      <div className="flex flex-col gap-1">
        <TextBody size={3}>&ldquo;{ quote }&rdquo;</TextBody>
        <TextSubtitle size={4}>{ author }</TextSubtitle>
      </div>
    </div>
  </div>
);

export default QuoteBanner;
